module.exports = __webpack_public_path__ + "media/images/revemoto-21c37b1eeec25f305f336964dfda3a48.png";